import { render } from "./IconVertialThreeDotCircle.vue?vue&type=template&id=f9ca6d24"
import script from "./IconVertialThreeDotCircle.vue?vue&type=script&lang=ts"
export * from "./IconVertialThreeDotCircle.vue?vue&type=script&lang=ts"
script.render = render

export default script